import { useQuery } from "@apollo/client"
import { LazyImage, Spinner, Swiper } from "@tmu/components/common"
import { OTHER_PARTNERS_QUERY } from "@tmu/src/apollo/dashboard/queries/partner"
import { getAllScreenTypes } from "@tmu/src/utils/mediaQueries"
import { FormattedMessage } from "gatsby-plugin-intl"
import { useRef } from "react"
import {
  StyledMainPartner,
  StyledMainPartnerLine,
  StyledMainPartnerTitle,
  StyledMainPartnersWrapper,
  StyledSlice,
} from "./index.styles"
import zapierImage from "../../../assets/images/logo_zapier.jpg"
import shopifyImage from "../../../assets/images/logo_shopify.jpg"
import woocommerceImage from "../../../assets/images/logo_woocommerce.jpg"
import prestashopImage from "../../../assets/images/logo_prestashop.jpg"

const SliceIntegrations = () => {
  const ref = useRef()
  const { isTablet, isDesktop, isWide } = getAllScreenTypes()

  const partners = [
    { logoUrl: zapierImage },
    { logoUrl: shopifyImage },
    { logoUrl: woocommerceImage },
    { logoUrl: prestashopImage },
  ]

  return (
    <StyledMainPartnersWrapper ref={ref}>
      <StyledMainPartnerTitle>
        <FormattedMessage
          id="homepage::integrations::title"
          defaultMessage="Integrations"
        />
      </StyledMainPartnerTitle>

      <StyledSlice data-testid="integrations" sliderLength={partners.length}>
        <Swiper isSmall={true} otherPartners={true}>
          {partners.map((partner, index) => {
            const imgSize = {
              src: partner.logoUrl,
              height: isWide ? 90 : isDesktop ? 50 : isTablet ? 40 : 20,
            }

            return (
              <StyledMainPartner key={index}>
                <LazyImage
                  altName={`partner-image-${index}`}
                  {...imgSize}
                  fit="cover"
                />
              </StyledMainPartner>
            )
          })}
        </Swiper>
      </StyledSlice>
    </StyledMainPartnersWrapper>
  )
}

export default SliceIntegrations
